import { is } from 'bpmn-js/lib/util/ModelUtil';
import { bausteinOf, getDefinitions, OPEN_EVENT } from '../utils/bausteine';

/**
 * Einstieg in einen Baustein.
 *
 * Eine Call Activity, die auf einen Baustein derselben Datei zeigt, bekommt
 * eine Schaltfläche „↳ Baustein öffnen". Der Wechsel selbst passiert nicht
 * hier: bpmn-js zeigt immer nur die Ebenen **eines** Diagramms, ein Baustein
 * liegt in einem eigenen. Umgeschaltet wird über `modeler.open(<Diagramm>)`,
 * und den Modeler hält die React-Seite. Darum wird hier nur ein Ereignis
 * ausgelöst, auf das der BpmnEditor hört.
 */
export default function BausteinNavigationProvider(eventBus, elementRegistry, overlays) {
  const gesetzt = {};

  function entferneAlle() {
    for (const id of Object.keys(gesetzt)) {
      try { overlays.remove(gesetzt[id]); } catch { /* schon fort */ }
      delete gesetzt[id];
    }
  }

  function knopf(element, baustein) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'baustein-open-btn';
    b.title = `Baustein „${baustein.name}" öffnen`;
    b.textContent = '↳ Baustein öffnen';
    b.addEventListener('click', (ev) => {
      ev.stopPropagation();
      eventBus.fire(OPEN_EVENT, {
        diagramId: baustein.diagram.id,
        processId: baustein.id,
        name: baustein.name,
        originId: element.id,
      });
    });
    return b;
  }

  function zeichneAlle() {
    entferneAlle();
    // Dieselbe Vorsicht wie im Baustein-Verzeichnis: canvas.getRootElement()
    // legt eine Ersatzwurzel ohne DI an, wenn noch nichts importiert ist, und
    // die bringt spaeter das Speichern zu Fall. Die definitions kommen darum
    // vom Element selbst.
    elementRegistry.forEach((element) => {
      if (!is(element, 'bpmn:CallActivity')) return;
      const definitions = getDefinitions(element.businessObject);
      if (!definitions) return;
      const baustein = bausteinOf(element.businessObject, definitions);
      if (!baustein) return;
      // Ohne eigenes Diagramm gibt es nichts zu zeigen. Das kommt bei Dateien
      // vor, die ganz ohne Anordnung ankommen: `ensureLayout` reicht an
      // bpmn-auto-layout weiter, und dessen layoutProcess ordnet nur den
      // ersten Prozess an. Ein Knopf, der nichts tut, ist schlechter als
      // keiner — im Baustein-Verzeichnis steht der Grund.
      if (!baustein.diagram) return;
      try {
        gesetzt[element.id] = overlays.add(element, 'baustein-open', {
          position: { bottom: -6, left: 0 },
          html: knopf(element, baustein),
        });
      } catch (e) {
        console.warn('[Baustein] Überlagerung nicht möglich:', element.id, e);
      }
    });
  }

  eventBus.on('import.render.complete', zeichneAlle);
  eventBus.on('elements.changed', zeichneAlle);
  eventBus.on('diagram.clear', entferneAlle);
}

BausteinNavigationProvider.$inject = ['eventBus', 'elementRegistry', 'overlays'];
